import Aboutus from "./pages/Aboutus";
import Contactus from "./pages/Contactus";
import Home from "./pages/Home";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import "./App.css";
import OrderOnline from "./pages/OrderOnline";
import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Cookie from "./pages/Cookies";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ServiceDisclaimer from "./pages/ServiceDisclaimer";
import PageNotFound from "./components/PageNotFound";
import MainPage from "./pages/MainPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/:restaurant/:id/*" element={<RestaurantWrapper />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;

const RestaurantWrapper = () => {
  let { restaurant, id } = useParams();

  const formattedRestaurant = restaurant.replace(/([a-z])([A-Z])/g, "$1 $2");

  const [restaurants, setRestaurants] = useState(null);

  console.log("Restaurants",restaurants);

  const getRestaurant = async () => {
    try {
      const response = await axios.get(
        `https://partnermeatwala.com/api/Vendor/GetVendorInfo?restname=${formattedRestaurant}&id=${id}`
      );

      const { success, vendorinfo } = response.data;
      if (success !== "1") {
        throw new Error("Failed to fetch data");
      }

      setRestaurants(vendorinfo);
    } catch (error) {
      console.error("Error fetching restaurant info:", error.message || error);
    }
  };

  useEffect(() => {
    getRestaurant();
  }, [formattedRestaurant, id]);

  return (
    <>
      <Navbar id={id} restaurants={restaurants} />
      {restaurants ? (
        <Routes>
          <Route path="/" element={<Home restaurants={restaurants} />} />
          <Route path="menu" element={<OrderOnline />} />
          <Route
            path="about-us"
            element={<Aboutus restaurants={restaurants} />}
          />
          <Route
            path="contact-us"
            element={<Contactus restaurants={restaurants} />}
          />
          <Route path="cookies" element={<Cookie />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
          <Route path="service-disclaimer" element={<ServiceDisclaimer />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      ) : (
        <p>Loading...</p>
      )}
      <Footer restaurants={formattedRestaurant} />
    </>
  );
};